
import { FolderOpenIcon } from '../Icons/FolderOpenIcon'
import { colors } from '../../styles/colors'
import { FolderIcon } from '../Icons/FolderIcon'
import { FileIcon } from '../Icons/FileIcon'
import {
    ArrowIconNew,
    StyledDot,
    StyledIconWrapper,
    StyledItemWrapper,
    StyledListItemText,
    StyledArrowWrapper,
    StyledTreeSubList
} from '../TreeList/treeList'
import { FolderOpenIconArrow } from '../Icons/FolderOpenIconArrow'
import { FolderIconArrow } from '../Icons/FolderIconArrow'
import { useTheme } from 'styled-components'
import { StyledContextMenu } from '../ContextMenu/StyledContextMenu'
import { ContextMenuTrigger } from 'react-contextmenu'
import PortalContextMenu from '../ContextMenu/PortalContextMenu'

const StorehouseItem = ({
    storehouse,
    setStorehousesActive,
    onClick = () => ({}), //get chosen Storehouse obj, 
    storehouseNodes,
    isClickable = storehouse => storehouse.isAllowToOrder,
    storehousesActive,
    renderExtraItemContent = (storehouse) => null,
    parentsWithSelectedChildren = [], //folderIcon with arrow
    selectedStorehouseId,
    setSelectedStorehouseId,
    getContextMenuOptions = () => [],
    maxUnitType
}) => {
    const theme = useTheme()

    const handleClickStorehouse = (storehouse) => {
        if (!storehouse) {
            console.warn("Undefined storehouse clicked")
            return
        }
        onClick(storehouse)
        setSelectedStorehouseId(storehouse.id)
    }

    const handleClickFolder = (storehouseId) => (e) => {
        e.stopPropagation()
        setStorehousesActive((prevState) => ({
            ...prevState,
            [storehouseId]: !prevState[storehouseId],
        }))
    }

    // Get child storehouses for rendering in a nested list
    const getChildStorehouse = (storehouse) => {
        return storehouseNodes.filter(child => child.parent && child.parent.id === storehouse.id)
    }
    const showChildren = (storehouse) => {
        if(maxUnitType && storehouse.stockUnitType===maxUnitType)
        {
            return false;
        }
        return storehouse.hasChildren;
    }
    return (
        <>
            <StyledContextMenu>

                <ContextMenuTrigger id={`${storehouse.id}_context`} holdToDisplay={-1}>
                    <StyledItemWrapper
                        isSelectable={!storehouse.hasChildren} // Pass isSelectable to determine style and clickability
                        isInvalid={!isClickable(storehouse)}
                        onClick={(e) => handleClickStorehouse(storehouse)} style={storehouse.id === selectedStorehouseId ? { boxShadow: `inset 0px 0px 0px 2px  ${theme.primaryColor}` } : {}}
                    >
                        {showChildren(storehouse) && (
                            <div className="d-flex" onClick={(e) => handleClickFolder(storehouse.id)(e)}>
                                <StyledArrowWrapper>
                                    <ArrowIconNew
                                        color={storehousesActive[storehouse.id] ? '#9c9c9c' : '#3a3a38'}
                                        variant={storehousesActive[storehouse.id] ? 'down' : 'right'}
                                    />
                                </StyledArrowWrapper>
                                <StyledIconWrapper>
                                    {storehousesActive[storehouse.id] ? (
                                        parentsWithSelectedChildren.includes(storehouse.id) ? (
                                            <FolderOpenIconArrow color={colors.gray7} />
                                        ) : (
                                            <FolderOpenIcon color={colors.gray7} />
                                        )
                                    ) : parentsWithSelectedChildren.includes(storehouse.id) ? (
                                        <FolderIconArrow color={colors.gray7} />
                                    ) : (
                                        <FolderIcon color={colors.gray7} />
                                    )}
                                </StyledIconWrapper>
                            </div>
                        )}
                        {!showChildren(storehouse) && (
                            <div className="d-flex">
                                <StyledDot>•</StyledDot>
                                <StyledIconWrapper>
                                    <FileIcon uniqueId={`costcenter-icon-${storehouse.id}`} color={colors.gray5} />
                                </StyledIconWrapper>
                            </div>
                        )}
                        <StyledListItemText>{storehouse.displayName}</StyledListItemText>
                        {renderExtraItemContent(storehouse)}
                    </StyledItemWrapper>

                    {showChildren(storehouse) && storehousesActive[storehouse.id] && (
                        // If the storehouse has children and it's open, show child storehouses
                        <StyledTreeSubList>
                            {getChildStorehouse(storehouse).map((childStorehouse) => (

                                <StorehouseItem
                                    key={childStorehouse.id}
                                    storehouse={childStorehouse}
                                    setStorehousesActive={setStorehousesActive}
                                    onClick={onClick}
                                    storehouseNodes={storehouseNodes}
                                    isClickable={isClickable}
                                    storehousesActive={storehousesActive}
                                    renderExtraItemContent={renderExtraItemContent}
                                    parentsWithSelectedChildren={parentsWithSelectedChildren}
                                    selectedStorehouseId={selectedStorehouseId}
                                    setSelectedStorehouseId={setSelectedStorehouseId}
                                    getContextMenuOptions={getContextMenuOptions}
                                    isSelectable={!childStorehouse.hasChildren}
                                    maxUnitType={maxUnitType}
                                />
                            ))}
                        </StyledTreeSubList>
                    )}
                </ContextMenuTrigger>
                {getContextMenuOptions(storehouse).length ? (
                    <PortalContextMenu
                        contextId={`${storehouse.id}_context`}
                        options={getContextMenuOptions(storehouse)}
                    />
                ) : null}
            </StyledContextMenu>
        </>
    )
}

export default StorehouseItem